import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Swords, Globe, Bot, Puzzle, TrendingUp } from 'lucide-react';
import './FeaturesGrid.css';

const features: { icon: ReactNode; key: string }[] = [
  { icon: <Swords size={28} />, key: 'Online' },
  { icon: <Globe size={28} />, key: 'Variants' },
  { icon: <Bot size={28} />, key: 'AI' },
  { icon: <Puzzle size={28} />, key: 'Puzzles' },
  { icon: <TrendingUp size={28} />, key: 'Rating' },
];

export default function FeaturesGrid() {
  const { t } = useTranslation();

  return (
    <section className="features-section">
      <div className="features-container">
        <span className="section-label">{t('home.landing.featuresLabel')}</span>
        <h2 className="section-title">{t('home.landing.featuresTitle')}</h2>
        <p className="section-subtitle">{t('home.landing.featuresSubtitle')}</p>

        <div className="features-grid">
          {features.map(({ icon, key }) => (
            <div className="feature-card" key={key}>
              <div className="feature-icon-box">{icon}</div>
              <h3 className="feature-title">{t(`home.landing.feature${key}`)}</h3>
              <p className="feature-desc">{t(`home.landing.feature${key}Desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
